import type { ShareCertSignature } from '@efdigital/ll-addon-content/types/components/parts/share-cert';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const ShareCert: TemplateOnlyComponent<ShareCertSignature> = <template>
  <button type="button" ...attributes>Share</button>
</template>;

export { ShareCert };
